import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { GlobalMessageService } from '../../services/global-message.service';
import { AdminService } from '../../services/admin.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { Constants } from '../../global/constants';

@Component({
  selector: 'admin-inbox',
  templateUrl: './admin-inbox.component.html',
})
export class AdminInboxComponent implements OnInit {
  loadingPage: boolean = true;
  inboxes: any[] = [];
  accounts: any[] = [];
  selectedAccount: any[];
  emailsAndNames: any[] = [];
  selectedEmailOrName: any[];
  exportData: any = null;
  selectedStatus: any[];
  inboxStatus: any[] = [];
  selectedAuth: any[];
  authStatus: any[] = [];
  selectedSku: any[];
  skuStatus: any[] = [];
  selectedBot: any[];
  botStatus: any[] = [];

  accountDDSettings: any = {
    text: 'Account Search',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  inboxDDSettings: any = {
    text: 'Active',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  authDDSettings: any = {
    text: 'All Statuses',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  skuDDSettings: any = {
    text: 'All Skus',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  botDDSettings: any = {
    text: 'All Email Types',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  emailDDSettings: any = {
    text: 'Email/Name Search',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  constructor(
    private globalMessageService: GlobalMessageService,
    private modalService: BsModalService,
    private adminService: AdminService,
    private cacheService: CacheService,
    private sessionService: SessionService,
    private constants: Constants,
  ) { }

  ngOnInit() {

    this.constants.inboxStatuses.forEach(i => {
      this.inboxStatus.push({ id: i.name, itemName: i.display, value: i.value });
    });

    this.constants.authStatuses.forEach(i => {
      this.authStatus.push({ id: i.name, itemName: i.display, value: i.value });
    });

    this.constants.skuStatuses.forEach(i => {
      this.skuStatus.push({ id: i.name, itemName: i.display, value: i.value });
    });

    this.constants.botStatuses.forEach(i => {
      this.botStatus.push({ id: i.name, itemName: i.display, value: i.value });
    });

    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  private initView() {

    const accountFilter = (this.selectedAccount && this.selectedAccount.length > 0) ? this.selectedAccount[0].id : null;
    const emailOrNameFilter = (this.selectedEmailOrName && this.selectedEmailOrName.length > 0) ? this.selectedEmailOrName[0].id : null;
    const inboxFilter = (this.selectedStatus && this.selectedStatus.length > 0) ? this.selectedStatus[0].value : null;
    const authFilter = (this.selectedAuth && this.selectedAuth.length > 0) ? this.selectedAuth[0].value : null;
    const skuFilter = (this.selectedSku && this.selectedSku.length > 0) ? this.selectedSku[0].value : null;
    const botFilter = (this.selectedBot && this.selectedBot.length > 0) ? this.selectedBot[0].value : null;

    if (this.accounts.length === 0) {
      this.adminService.getActiveAccounts().subscribe((result: any) => {
        result.forEach((a) => {
          this.accounts.push({ id: a._id, itemName: a.name });
        });
      });
    }

    if (this.emailsAndNames.length === 0) {
      this.adminService.getAllInboxes().subscribe((result: any) => {
          result.forEach((i) => {
            const id = i._id;
            this.emailsAndNames.push({ id: id, itemName: i.email_address });
            this.emailsAndNames.push({ id: id, itemName: i.name });
          });
        }
      );
    }

    this.adminService.getAllInboxes(accountFilter, inboxFilter, authFilter, skuFilter, botFilter, emailOrNameFilter).subscribe(
      (result: any) => {
        this.inboxes = result;
        this.loadingPage = false;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  resetFilters() {
    this.selectedAccount = null;
    this.selectedEmailOrName = null;
    this.selectedStatus = null;
    this.selectedAuth = null;
    this.selectedSku = null;
    this.exportData = null;
    this.selectedBot = null;
    this.accountDDSettings.text = 'Active';
    this.authDDSettings.text = 'All Statuses';
    this.skuDDSettings.text = 'All Skus';
    this.botDDSettings.text = 'All Email Types';
    this.initView();
  }

  backfill(inboxId: string) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to backfill this inbox`,
        confirm: () => {
          me.backfillConfirm(inboxId).then(() => {
            me.globalMessageService.message('Inbox will be backfilled');
          });
        }
      }
    }));
  }

  backfillConfirm(inboxId: string) {
    return new Promise((resolve, reject) => {
      this.adminService.backfillInbox(inboxId).subscribe(
        (result: any) => {
          resolve();
        },
        (error) => {
          reject();
        }
      );
    });
  }

  refresh() {
    this.initView();
    this.exportData = null;
  }

  export() {
    let items = JSON.parse(JSON.stringify(this.inboxes)).map((i) => {
      switch (i.auth_status) {
        case 0:
          i.auth_status = 'Invited';
          break;
        case 2:
          i.auth_status = 'Good';
          break;
        case 3:
          i.auth_status = 'Failing';
          break;
      }
      return i;
    });
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(items[0]);
    let csv: any = items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    this.exportData = csv.join('\r\n');
  }

  removeInbox(accountId: string, emailAddress: string) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to delete this inbox from the system`,
        confirm: () => {
          me.removeInboxConfirm(accountId, emailAddress);
        }
      }
    }));
  }

  removeInboxConfirm(accountId: string, emailAddress: string) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Are you sure that you want to remove all the data related to this inbox from the system? This action is not reversible`,
        confirm: () => {
          me.inboxRemovalConfirm(accountId, emailAddress).then(() => {
            me.globalMessageService.message('Inbox will be removed from the system');
          });
          me.removeAccountSource(accountId, emailAddress);
        }
      }
    }));
  }

  removeAccountSource(accountId: string, emailAddress: string) {
    return new Promise((resolve, reject) => {
      this.adminService.removeAccountSource(accountId, emailAddress).subscribe(
        (resut: any) => {
          resolve();
        },
        (error) => {
          reject();
        }
      );
    });
  }

  inboxRemovalConfirm(accountId: string, emailAddress: string) {
    return new Promise((resolve, reject) => {
      this.adminService.removeInbox(accountId, emailAddress).subscribe(
        (result: any) => {
          resolve();
        },
        (error) => {
          reject();
        }
      );
    });
  }

  changeStatus(inbox) {
    this.selectedStatus = [inbox];
    this.refresh();
  }

  changeAuth(auth) {
    this.selectedAuth = [auth];
    this.refresh();
  }

  changeSku(sku) {
    this.selectedSku = [sku];
    this.refresh();
  }

  changeBot(bot) {
    this.selectedBot = [bot];
    this.refresh();
  }

  changeEmailOrName(emailOrName) {
    this.selectedEmailOrName = [emailOrName];
    this.refresh();
  }

  changeAccount(account) {
    this.selectedAccount = [account];
    this.refresh();
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-inbox/admin-inbox.component.ts